import { render, staticRenderFns } from "./eliminacion-residuos-editar.vue?vue&type=template&id=31eae46d&scoped=true&"
import script from "./eliminacion-residuos-editar.vue?vue&type=script&lang=js&"
export * from "./eliminacion-residuos-editar.vue?vue&type=script&lang=js&"
import style0 from "./eliminacion-residuos-editar.vue?vue&type=style&index=0&id=31eae46d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eae46d",
  null
  
)

export default component.exports